import React, { FunctionComponent } from "react";

import TracPage from "@services/tracpage/types/trac-page";
import { TracPageFeatureItemType } from "@services/tracpage/types/trac-page-feature-item";
import { TourItem } from "../tour-item";
import { SongLink } from "../song-link";
import { ProductItem } from "../product-item";

interface SidebarFeaturedItemProps {
  data: any;
  pageData: TracPage;
}

export const SidebarFeaturedItem: FunctionComponent<
  SidebarFeaturedItemProps
> = ({ data, pageData }) => {
  if (!data || !pageData.featuredItem) {
    return null;
  }

  switch (pageData.featuredItem.type) {
    case TracPageFeatureItemType.MusicRelease:
      return null;
    case TracPageFeatureItemType.MerchProduct:
      return (
        <ProductItem
          product={data}
          hasAnimation
          isHighlight
          siteData={pageData}
        />
      );
    case TracPageFeatureItemType.TracLink:
      return (
        <SongLink
          dsps={[]}
          className="highlight"
          inSidebar
          data={data}
          artistName={data.title}
        />
      );
    case TracPageFeatureItemType.TourEvent:
      return (
        <TourItem
          id={data.id}
          className="highlight"
          title={data.title}
          location={data.location}
          date={data.date}
          href={data.href}
          isHighlight
        />
      );
    default:
      return null;
  }
};
